import React from "react";
import styled from "styled-components";
import PropTypes from 'prop-types';
import MsxIcons from "../features/msx-icons";


const CategoryHeaderWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 0px;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;

const ArrowIconWrapper = styled.div`
  transition: transform 0.3s;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  width: 32px;
  height: 32px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CategoryContent = styled.div`
  position: absolute; top: 100%; left: 0px; right: 0px;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 2;
  cursor: default;
  ${props => props.needScroll && `
    height: 250px;
    overflow-y: hidden;
  `}

`;

class Dropdown extends React.Component {

  static propTypes = {
    id: PropTypes.string,
    onHeaderClick: PropTypes.func,
    renderHeaderContent: PropTypes.func,
    renderContent: PropTypes.func,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    needScroll: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.props.isOpen) {
      this.props.onClose();
    }
  }

  render() {
    const idProps = {};
    if (this.props.id) {
      idProps['id'] = this.props.id;
    }

    return (
      <CategoryHeaderWrapper {...idProps} ref={this.wrapperRef} onClick={() => {
        this.props.onHeaderClick();
      }}>
        {this.props.renderHeaderContent()}
        <ArrowIconWrapper isOpen={this.props.isOpen}>
          <MsxIcons name="down-arrow" size="small"></MsxIcons>
        </ArrowIconWrapper>
        {this.props.isOpen && <CategoryContent needScroll={this.props.needScroll} onClick={(event) => { event.stopPropagation() }}>
          {this.props.renderContent()}
        </CategoryContent>}
      </CategoryHeaderWrapper>
    );
  }
}

export default Dropdown;
